import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ReduxStateActivity } from "../../types/redux/reduxStateActivity";
import { SiteDepartmentLineWorkorder } from "../../types/siteDepartmentLineWorkorder";
import { initialStateActivitiy } from "../defaultState";
import {
    closeConsumption,
    closeLabelling,
    getActivitiesConsByDepartment,
    getActivitiesLablByDepartment
} from "../../aplApi/activitiesHelper";
import { getAplError } from "../../aplApi/exceptionHelper";
import { Activity } from "../../types/activity";

export const getActConsRedux: any = createAsyncThunk("activities/getActConsRedux", async (props: SiteDepartmentLineWorkorder, thunkApi) => {
    try {
        return (await getActivitiesConsByDepartment(props.departmentId)).data;
    } catch (error: any) {
        return thunkApi.rejectWithValue(getAplError(error, error.response.data));
    }
});

export const getActLablRedux: any = createAsyncThunk("activities/getActLablRedux", async (props: SiteDepartmentLineWorkorder, thunkApi) => {
    try {
        return (await getActivitiesLablByDepartment(props.departmentId)).data;
    } catch (error: any) {
        return thunkApi.rejectWithValue(getAplError(error, error.response.data));
    }
});

export const closeConsRedux: any = createAsyncThunk("activities/closeConsRedux", async (activity: Activity, thunkApi) => {
    try {
        await closeConsumption(activity.lineId, activity.operationId);
        return (await getActivitiesConsByDepartment(activity.departmentId)).data;
    } catch (error: any) {
        return thunkApi.rejectWithValue(getAplError(error, error.response.data));
    }
});

export const closeLablRedux = createAsyncThunk("activities/closeLablRedux", async (activity: Activity, thunkApi) => {
    try {
        await closeLabelling(activity.lineId, activity.operationId);
        return (await getActivitiesLablByDepartment(activity.departmentId)).data;
    } catch (error: any) {
        return thunkApi.rejectWithValue(getAplError(error, error.response.data));
    }
});

const activityFeature: any = createSlice({
    name: "activities",
    initialState: initialStateActivitiy,
    reducers: {
        setConsRedux: function (state, action) {
            return {
                ...state,
                actCons: action.payload,
                actConsError: null
            };
        },
        clearConsRedux: function (state: any, action) {
            return {
                ...state,
                actCons: [],
                actConsError: null,
                actConsFirstLoaded: false
            };
        },
        setLablRedux: function (state, action) {
            return {
                ...state,
                actLabl: action.payload,
                actLablError: null
            };
        },
        clearLablRedux: function (state) {
            return {
                ...state,
                actLabl: [],
                actLablError: null,
                actLablFirstLoaded: false,
            };
        },
        clearAssignedLineIdRedux: function (state) {
            return {
                ...state,
                actConsAssignedLineId: null,
                actLablAssignedLineId: null
            };
        },
        clearClosedLineIdRedux: function (state) {
            return {
                ...state,
                actConsClosedLineId: null,
                actLablClosedLineId: null
            };
        },
        clearActivityErrorRedux: function (state) {
            return {
                ...state,
                actConsError: null,
                actLablError: null
            };
        }
    },
    extraReducers: builder => {
        builder
            .addCase(getActConsRedux.pending, state => {
                return {
                    ...state,
                    actConsLoading: true
                } as ReduxStateActivity;
            })
            .addCase(getActConsRedux.fulfilled, (state, action) => {
                return {
                    ...state,
                    actCons: [...action.payload],
                    actConsError: null,
                    actConsLoading: false,
                    actConsFirstLoaded: true
                } as ReduxStateActivity;
            })
            .addCase(getActConsRedux.rejected, (state, action) => {
                return {
                    ...state,
                    actConsLoading: false,
                    actConsError: action.error.code === "ERR_CANCELED" ? null : action.payload
                } as ReduxStateActivity;
            });

        builder
            .addCase(getActLablRedux.pending, state => {
                return {
                    ...state,
                    actLablLoading: true
                } as ReduxStateActivity;
            })
            .addCase(getActLablRedux.fulfilled, (state, action) => {
                return {
                    ...state,
                    actLabl: [...action.payload],
                    actLablError: null,
                    actLablLoading: false,
                    actLablFirstLoaded: true
                } as ReduxStateActivity;
            })
            .addCase(getActLablRedux.rejected, (state, action) => {
                return {
                    ...state,
                    actLablLoading: false,
                    actLablError: action.error.code === "ERR_CANCELED" ? null : action.payload
                } as ReduxStateActivity;
            });

        builder
            .addCase(closeConsRedux.pending, state => {
                return {
                    ...state,
                    actConsLoading: true
                } as ReduxStateActivity;
            })
            .addCase(closeConsRedux.fulfilled, (state, action) => {
                return {
                    ...state,
                    actCons: [...action.payload],
                    actConsError: null,
                    actConsLoading: false,
                    actConsFirstLoaded: true,
                    actConsClosedLineId: action.payload.length > 0 ? action.payload[0].lineId : null
                } as ReduxStateActivity;
            })
            .addCase(closeConsRedux.rejected, (state, action) => {
                return {
                    ...state,
                    actConsLoading: false,
                    actConsError: action.meta.arg.lineId
                } as ReduxStateActivity;
            });

        builder
            .addCase(closeLablRedux.pending, state => {
                return {
                    ...state,
                    actLablLoading: true
                } as ReduxStateActivity;
            })
            .addCase(closeLablRedux.fulfilled, (state, action) => {
                return {
                    ...state,
                    actLabl: [...action.payload],
                    actLablError: null,
                    actLablLoading: false,
                    actLablFirstLoaded: true,
                    actLablClosedLineId: action.meta.arg.lineId
                } as ReduxStateActivity;
            })
            .addCase(closeLablRedux.rejected, (state, action) => {
                return {
                    ...state,
                    actLablLoading: false,
                    actLablError: action.error.code === "ERR_CANCELED" ? null : action.payload
                } as ReduxStateActivity;
            });
    }
});

export const { setConsRedux, clearConsRedux, setLablRedux, clearLablRedux, clearAssignedLineIdRedux, clearClosedLineIdRedux, clearActivityErrorRedux } = activityFeature.actions;
export default activityFeature.reducer;
